// extracted by mini-css-extract-plugin
export default {"container":"ScrollUp_container__GvyUG","containerHidden":"ScrollUp_containerHidden__QXfmd"};